export const MAX_PAGE_CONTENT_WIDTH = 968;
export const MAX_MODAL_CONTENT_WIDTH = 848;
export const MIN_HEADER_HEIGHT = 150;
export const REVIEW_SECTION_ID = "product-detail-reviews";
